/**
 * MSW browser worker entry — used only by the e2e test build
 * (gated on `import.meta.env.VITE_E2E_MSW === 'on'`).
 *
 * Loaded lazily by `src/index.jsx` so it has zero cost for the normal
 * `yarn start` dev loop. The Playwright-facing dev server is launched
 * via `yarn start:e2e` (see package.json).
 *
 * The worker is also exposed on `window.mswWorker` so the e2e helper
 * `e2e/helpers/mockApi.ts` can call `worker.use(...)` / `worker.resetHandlers()`
 * to activate per-test scenarios from the Playwright side.
 *
 * Prerequisite: `npx msw init public/ --save` was run once to emit
 * `public/mockServiceWorker.js`. That file is committed (MSW requires it
 * at a stable public URL).
 */
import { setupWorker } from 'msw/browser'
import { http, HttpResponse } from 'msw'
import { handlers } from './handlers'

export const worker = setupWorker(...handlers)

// Expose for cross-frame (Playwright) handler overrides. `mswApplyScenario`
// is the bridge used by `e2e/helpers/mockApi.ts` so the spec side does not
// have to dynamic-import `msw` inside `page.evaluate()` (browser bare-module
// resolution is unreliable there).
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-underscore-dangle
  window.mswWorker = worker
  window.mswApplyScenario = (def) => {
    const method = (def.method || 'GET').toLowerCase()
    const handler = http[method](def.path, () =>
      HttpResponse.json(def.body, { status: def.status }),
    )
    worker.use(handler)
  }
}
